<elder-single-pane-wrapper>
  <elder-table
    class="flex"
    [data]="data"
    [cleanUp]="true"
    [selectionVisible]="false"
    [selectionMultiEnabled]="false"
    matSort
    (itemClick)="onItemClick($event)"
  >
    <elder-data-toolbar *elderTableToolbar [canAdd]="false" [canRemove]="false" [canMore]="false">
      <ng-template elderToolbarContent="center">
        <!-- Search Box -->
        <elder-search-box
          class="flex p-xs"
          dense
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
        >
          <!-- Advanced search -->
          <elder-search-panel class="layout-col p-sm"> </elder-search-panel>
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'ID' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">{{ group.id }}</td>
    </ng-container>

    <!-- orderReferenceNumber Column -->
    <ng-container matColumnDef="orderReferenceNumber">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.orderReference' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">{{ group.orderReferenceNumber }}</td>
    </ng-container>

    <!-- packageGroups Column -->
    <ng-container matColumnDef="packageGroupsCount">
      <th mat-header-cell *matHeaderCellDef style="width: 5%" elderNumberCell>
        {{ 'packageGroups.count' | translate }}
      </th>
      <td mat-cell *matCellDef="let group" elderNumberCell>
        {{ group.packageGroups?.length || '?' }}
      </td>
    </ng-container>

    <!-- expectedWeight Column -->
    <ng-container matColumnDef="expectedPackageWeight">
      <th mat-header-cell *matHeaderCellDef style="width: 5%" elderNumberCell>
        {{ 'context.expectedWeight' | translate }}
      </th>
      <td mat-cell *matCellDef="let group" elderNumberCell>
        {{ group.expectedPackageWeight | elderQuantity }}
      </td>
    </ng-container>

    <!-- spacer Column -->
    <ng-container matColumnDef="spacer">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let group"></td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        {{ group.createdAt | date: 'short' }}
      </td>
    </ng-container>

    <!-- modifiedAt -->
    <ng-container matColumnDef="modifiedAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.modifiedAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        {{ group.modifiedAt | date: 'short' }}
      </td>
    </ng-container>
  </elder-table>
</elder-single-pane-wrapper>
